import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { repositoryFactory } from '@rammetec/data-access';
/**
 * Returns a `sync()` function that performs a full data refresh:
 * clears the repository cache layer and invalidates all React Query entries. (PW-01)
 */
export function useSync() {
    const queryClient = useQueryClient();
    const sync = useCallback(async () => {
        await repositoryFactory.invalidateAllCaches();
        await queryClient.invalidateQueries();
    }, [queryClient]);
    return { sync };
}
//# sourceMappingURL=useSync.js.map